import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import BlankLayout from '../../../../components/layout/BlankLayout';

export default (
  <Route
    key="/perfectbeauty/youcam/terms-of-service-api"
    element={<BlankLayout />}
  >
    <Route
      path="perfectbeauty/youcam/terms-of-service-api"
      element={<AsyncPage />}
    />
  </Route>
);
